import { makeStyles } from '@material-ui/core';

const styles = makeStyles({
    title: {
        fontFamily: 'inherit',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#3d454a'
    },
    listHeader: {
        borderBottom: 'solid 1px #eaeaea',
        fontSize: '13px',
        fontWeight: 'bold',
        padding: '8px 0'
    },
    formName: {
        // minWidth: '100px',
        flex: '0 1 30%'
        // width: '40%'
    },
    desiredClinic: {
        flex: '0 1 35%'
    },
    buttonWrapper: {
        minWidth: '130px'
    },
    addBtn: {
        boxShadow: '0 4px 10px 0 rgba(116, 119, 131, 0.24)',
        backgroundColor: '#1b90fa',
        minWidth: '126px',
        height: '42px',
        borderRadius: '6px',
        position: 'sticky',
        // left: props.rtl ? '17px' : 'unset',
        // right: props.rtl ? 'auto' : '17px',
        bottom: '23px',
        padding: '6px 14px'
        // margin:"24px"
    },
    formContainer: {
        minHeight: '100vh',
        backgroundColor: '#fff',
        // overflow: 'auto',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        padding: '24px',
        position: 'relative'
        // overflow: 'auto'
    },
    addText: {
        padding: '0 8px'
    },
    emptyMessage: {
        height: '90vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'gray',
        textAlign: 'center',
        '& p': {
            padding: '10px',
            lineHeight: '1.5em'
        }
    },
    progressContainer: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh'
    },
    progress: {
        color: '#063f5e'
    },
    warningRow: {
        marginTop: '24px',
        display: 'flex',
        alignItems: 'center',
        '& img': {
            width: '20px',
            height: '20px'
        }
    },
    warningText: {
        fontFamily: 'inherit',
        fontSize: '13px',
        fontWeight: 'normal',
        lineHeight: 1.69,
        color: '#545e66',
        margin: '0 8px'
    }
});

export { styles };
